import React from 'react';
import { DateTime } from "luxon";

import CSS from './styles.scss';
import NoteEditor from 'components/Notebook/AnnotationList/NoteEditor';

import { ItemEdit as IEIcon } from 'Shared/Icons';
import { Highlight as HIcon } from 'Shared/Icons';


const CardViews = ({ bodyStyle, cancelEdit, deleteHighlight, addNote, editNote, highlight, isEditingNote, isAddingNote, noteText, saveNote, onKeyDown, goToCfi }) => {
  
  const showAffordances = () => {
    let editCSS = CSS['edit'];
    let addCSS = CSS['add'];

    if (highlight.noteText) {
      if (isEditingNote) {
        editCSS = `${editCSS} ${CSS['edit__active']}`;
      }

      return (
        <div className={ CSS['card-actions'] }>
          <button id={ `action#${highlight.id}` } data-test-id="edit-note-button" className={ editCSS } onClick={ editNote } onKeyDown={ onKeyDown } tabIndex={ isEditingNote ? -1 : 0 }>Edit Note</button>
          <div style={{ width: "15px"}}></div>
          <button id={ `delete#${highlight.id}` } data-test-id="delete-note-button" className={ CSS['delete'] } onClick={ deleteHighlight } onKeyDown={ onKeyDown } tabIndex="0">Delete</button>
        </div>
      );
    }

    if (isAddingNote) {
      addCSS = `${addCSS} ${CSS['add__active']}`;
    }

    return (
      <div className={ CSS['card-actions'] }>
        <button id={ `action#${highlight.id}` } data-test-id="add-note-button" className={ addCSS } onClick={ addNote } onKeyDown={ onKeyDown } tabIndex={ isAddingNote ? -1 : 0 }>Add Note</button>
        <div style={{ width: "15px"}}></div>
        <button id={ `delete#${highlight.id}` } data-test-id="delete-note-button" className={ CSS['delete'] } style={{ 'marginLeft': 'auto' }} onClick={ deleteHighlight } onKeyDown={ onKeyDown } tabIndex="0">Delete</button>
      </div>
    );
  };

  const goToClickSelectedText = () => {
    goToCfi(highlight.cfi);
  }

  return (
    <div id={ `card#${highlight.id}` } data-test-id={ highlight.noteText ? 'highlight-with-note-card' : 'highlight-card' } className={ CSS['card'] }>

      <div className={ CSS['header'] }>
        {!highlight.noteText
          ? <HIcon fill="#686868" />
          : <IEIcon fill="#686868" />
        }
        {!highlight.noteText
          ? <span className={ CSS['annoType'] }>highlight</span>
          : <span className={ CSS['annoType'] }>highlight and note</span>
        }

        { showAffordances() }
      </div>

      <div className={ CSS['body'] }>
        <div className={ CSS['highlight'] } data-test-id="card-highlight-body" style={ bodyStyle } tabIndex="0" onClick={ goToClickSelectedText } role={"button"} onKeyPress={(e) => {
          if(e.code === "Space" || e.code === "Enter") {
            goToClickSelectedText() 
          }
        }}>{ highlight.selectedText }</div>
        {highlight.noteText || isAddingNote
          ? <NoteEditor isEditingNote={ isEditingNote } highlight={ highlight } cancelEdit={ cancelEdit } saveNote={ saveNote } goToCfi={ goToCfi }/>
          : null
        }
      </div>

      <div className={ CSS['footer'] }>
        <span className={ CSS['last-update'] }>{ DateTime.fromRFC2822(highlight.lastModifiedAt).toRelative() }</span>
      </div>
    </div>
  );
};

CardViews.propTypes = {};


export default CardViews;
